<template>
  <div class="ball">
    <span class="tag clickable"
      @click="onBallSelected(ball)">{{ball.over_str}}</span>
    <span>
      <span v-html="ball.comment"></span>
    </span>
  </div>
</template>
<script>
import { DataState } from '@/state'
export default {
  props: {
    match: Object,
    ball: Object
  },
  methods: {
    onBallSelected (ball) {
      this.$emit('ballSelected', ball)
    }
  }
}
</script>
